import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import SEO from "../../layout/SEO";
import ArticlesGrid from "../../layout/ArticlesGrid";
import { withRouter } from "react-router-dom";

class PPEArticles extends Component {
  componentDidMount() {
    window.resetScript();
  }

  render() {
    return (
      <>
        <SEO
          title="Projet Personnel Encadré"
          description="Découvrez mes projets personnels encadrés et les réalisations effectuées dans ce cadre."
          keywords="projet personnel encadré, PPE, projets, réalisations"
        />
        <Header active="Projet Personnel Encadré" modeDark={true} />
        <BannerSimple 
          title="Projet Personnel Encadré" 
          boxElement={[
            { name: "Accueil", link: "/" },
            { name: "Projet Personnel Encadré", link: window.location.pathname }
          ]} 
        />
        
        <section className="portfolio_details_area section-gap">
          <div className="container">
            <ArticlesGrid 
              type="PPE"
              itemsPerPage={12}
              emptyMessage="Aucun article de projet personnel encadré trouvé"
            />
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

export default withRouter(PPEArticles);

